import {
  TrackingBasket,
  trackPageViewWithProducts,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackWishlistPageView} from '@aboutyou/legacy-tracking-sdk/src/ay-tracking/types/tracking-wishlist';
import {useTracking} from '../utils/utils';

export const useTrackPageView = () => {
  const {TrackingClient} = useTracking();

  return (
    props: {basket: TrackingBasket} | {wishlist: TrackWishlistPageView},
  ) => {
    TrackingClient.track(trackPageViewWithProducts(props));
  };
};
